import React from 'react';
import styled from 'styled-components';

import CloseIcon from '../../../atoms/icons/CloseIcon';

import mq from '../../../../styles/breakpoints';
import Colors from '../../../../styles/colors';

interface Props {
  onClickHandler: () => void;
}

const NavigationCancelButton = ({ onClickHandler }: Props) => (
  <CancelButtonContainer
    data-testid="close-button"
    aria-label="Sluit navigation"
    onClick={() => onClickHandler()}
  >
    <CloseIcon ariaHidden color={Colors.white} width="0.7em" height="0.7em" />
  </CancelButtonContainer>
);

export default NavigationCancelButton;

const CancelButtonContainer = styled.a`
  align-items: center;
  border-radius: ${({ theme }) => theme.radiuses.S};
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;

  ${mq.from.breakpoint.L`
    height: 44px;
    width: 44px;
`}

  &:hover {
    background-color: ${({ theme }) => theme.colors.abnGreen200};
  }
  &:active: {
    background-color: ${({ theme }) => theme.colors.abnGreen400};
  }
`;
